import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RevisionGetLockStatusPathParameters } from 'api/actions/revision-get-lock-status/revision-get-lock-status-path-parameters';
import { RevisionGetLockStatusResponse } from 'api/actions/revision-get-lock-status/revision-get-lock-status-response';

type RevisionGetLockStatusQueryParameters = Record<string, any>;

/**
 * The path of the RevisionGetLockStatus action.
 */
export const revisionGetLockStatusActionPath = new SweetPath<keyof RevisionGetLockStatusPathParameters>(
  '/api/revision/lock-status/{revisionId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized RevisionGetLockStatus actions.
 */
export default function createRevisionGetLockStatusAction(axios: AxiosInstance) {
  return function revisionGetLockStatusAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RevisionGetLockStatusPathParameters;
    query?: RevisionGetLockStatusQueryParameters;
  }) {
    const path = revisionGetLockStatusActionPath.insert(parameters);

    return axios.request<RevisionGetLockStatusResponse, RevisionGetLockStatusResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
